// extracted by mini-css-extract-plugin
export default {"tab":"ClientTab_tab__DyXSW"};